module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-head"
  }, [_c('div', {
    staticClass: "head-left"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.corpName))])]), _vm._v(" "), _c('span', {
    staticClass: "slogan"
  }, [_vm._v("欢迎您使用销帮帮CRM")]), _vm._v(" "), (_vm.isDingTalk) ? _c('span', {
    staticClass: "open-browser",
    on: {
      "click": _vm.openBrowser
    }
  }, [_vm._v("在浏览器中打开")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [(_vm.userAvatar) ? _c('a', {
    staticClass: "avatar",
    attrs: {
      "href": "/user/myInfo.html"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userAvatar,
      "alt": _vm.userName
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "name",
    class: {
      active: _vm.optionShow
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.optionShow = !_vm.optionShow
      }
    }
  }, [_vm._v(_vm._s(_vm.userName)), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optionShow),
      expression: "optionShow"
    }],
    staticClass: "option"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "remind"
  }, [_c('span', {
    on: {
      "click": _vm.clickMessageBox
    }
  }, [_vm._v("提醒（" + _vm._s(_vm.getRemindCount < 0 ? 0 : _vm.getRemindCount) + "）")])]), _vm._v(" "), (_vm.getCTIStatus) ? _c('div', {
    staticClass: "cti-note"
  }, [(_vm.moduleType === 305) ? _c('div', {
    staticClass: "note-btn head-item",
    on: {
      "click": function($event) {
        _vm.$router.push('/callCenter/calllog?result=0')
      }
    }
  }, [_c('i', {
    staticClass: "web-icon-callin"
  }), _vm._v(" "), _c('span', {
    staticClass: "note-text"
  }, [_vm._v("未接来电")]), _vm._v(" "), (_vm.getMissCallCount) ? _c('i', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.getMissCallCount))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 302) ? _c('div', {
    staticClass: "note-btn head-item",
    on: {
      "click": function($event) {
        _vm.noteListShow = !_vm.noteListShow
      }
    }
  }, [_c('i', {
    staticClass: "web-icon-callin"
  }), _vm._v(" "), _c('span', {
    staticClass: "note-text"
  }, [_vm._v("未接来电")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]) : _vm._e(), _vm._v(" "), (_vm.noteListShow) ? _c('ul', {
    staticClass: "note-list"
  }, [_vm._l((_vm.missedCallList), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "call-num"
    }, [_vm._v(_vm._s(item.anotherPhoneNum))]), _vm._v(" "), _c('span', {
      staticClass: "call-name"
    }, [(item.refType === 404) ? [_vm._v("\n            " + _vm._s(item.refName) + "\n          ")] : _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openDetail(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.refName) + "\n          ")])], 2), _vm._v(" "), _c('span', {
      staticClass: "call-btn",
      on: {
        "click": function($event) {
          _vm.makeCall(item.anotherPhoneNum)
        }
      }
    }, [_c('i', {
      staticClass: "web-icon-callout"
    })])])
  }), _vm._v(" "), (!_vm.missedCallList.length) ? _c('li', {
    staticClass: "empty"
  }, [_vm._v("没有未接来电")]) : _vm._e()], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "/user/myInfo.html"
    }
  }, [_vm._v("个人信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "/user/logout.html"
    }
  }, [_vm._v("退出登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7779da97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/common-head.vue
// module id = 1304
// module chunks = 82